import React, { useState, useEffect } from 'react';

const InteriorCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [visibleItems, setVisibleItems] = useState(3); // default for large screens

  const carouselData = [
    {
      image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
      title: "Modern Sofa Set",
      content: "Elegant and comfortable seating designed to enhance any living room space."
    },
    {
      image: "assets/interior/interior4.jpg",
      title: "Luxury Wooden Door",
      content: "Crafted from premium wood with a sleek finish, perfect for family gatherings."
    },
    {
      image: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
      title: "Designer Lighting",
      content: "Stylish pendant and ceiling lights that brighten your interiors with elegance."
    },
    {
      image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
      title: "Contemporary Wardrobe",
      content: "Spacious, functional, and designed with a modern touch for organized living."
    },
    {
      image: "https://images.unsplash.com/photo-1537726235470-8504e3beef77?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
      title: "Minimalist Coffee Table",
      content: "A sleek centerpiece that blends functionality with timeless interior design."
    }
  ];

  // Responsive visibleItems
  useEffect(() => {
    const updateVisibleItems = () => {
      if (window.innerWidth < 640) {
        setVisibleItems(1); // Mobile
      } else if (window.innerWidth < 1024) {
        setVisibleItems(2); // Tablet
      } else {
        setVisibleItems(3); // Desktop
      }
    };

    updateVisibleItems();
    window.addEventListener("resize", updateVisibleItems);

    return () => window.removeEventListener("resize", updateVisibleItems);
  }, []);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    const newIndex = currentIndex === 0 ? carouselData.length - visibleItems : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    const newIndex = currentIndex >= carouselData.length - visibleItems ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        const newIndex = currentIndex >= carouselData.length - visibleItems ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying, visibleItems, carouselData.length]);

  return (
    <div className="w-full  mx-auto p-4">
      <h2 className="text-2xl font-bold text-center mb-2 text-gray-800">
        Modern Interior Design Collection
      </h2>

      <div className="relative">
        {/* Carousel container */}
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * (100 / visibleItems)}%)` }}
          >
            {carouselData.map((slide, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-2"
                style={{ width: `${100 / visibleItems}%` }}
              >
                <div className="bg-white rounded-lg shadow-md overflow-hidden h-full">
                  <div className="h-48 sm:h-56 md:h-64 overflow-hidden">
                    <img
                      src={slide.image}
                      alt={slide.title}
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-semibold text-lg mb-1 text-gray-800">{slide.title}</h3>
                    <p className="text-gray-600 text-sm">{slide.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation buttons */}
        <button
          onClick={goToPrevious}
          className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={goToNext}
          className="absolute right-0 top-1/2 -translate-y-1/2 -mr-6 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 transition-colors"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Indicators */}
      <div className="flex justify-center mt-6 space-x-2">
        {Array.from({ length: carouselData.length - visibleItems + 1 }).map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all ${currentIndex === index ? 'bg-blue-600 scale-125' : 'bg-gray-300'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default InteriorCarousel;
